import React, { useState } from 'react';
import { motion } from 'framer-motion';

export const Tabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="w-full">
      <div className="flex overflow-x-auto hide-scrollbar border-b border-warm-stone/40 mb-8 md:mb-12">
        <div className="flex space-x-8 min-w-max px-2">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`
                relative py-4 text-sm md:text-base font-medium tracking-wide transition-colors duration-300
                ${activeTab === index ? 'text-estate-bronze' : 'text-deep-charcoal/60 hover:text-deep-charcoal'}
              `}
            >
              {tab.label}
              {activeTab === index && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-estate-bronze"
                  initial={false}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
            </button>
          ))}
        </div>
      </div>
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        {tabs[activeTab].content}
      </motion.div>
    </div>
  );
};